<div class="video-player__container">
  <button mat-icon-button class="dialog-close" (click)="close()">
    <mat-icon>close</mat-icon>
  </button>
  <video
    controls
    class="video-player"
    muted
    autoplay
    disablepictureinpicture
    loop
    controlsList="nodownload nofullscreen"
    (playing)="onVideoPlaying()"
    [poster]="(videoDetails$ | async)?.thumbnailUrl ? (videoDetails$ | async)?.thumbnailUrl : ''"
  >
    <source [src]="(videoDetails$ | async)?.details?.url" type="video/mp4" />
    <source [src]="(videoDetails$ | async)?.details?.url" type="'video/mp4; codecs=avc1.4D401E, mp4a.40.2'" />
  </video>
</div>
